import { useMutation, useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '../../config/constants';
import {
  addRoleByIdFn,
  deleteRoleByIdFn,
  getRolesFn,
  updateRoleByIdFn,
} from '../../transactions/user/admin';
import { queryClient } from '../../utils/queryClient';

const { USER_ROLES } = QUERY_KEYS;

export const useGetRoles = () => {
  // updateRoleByIdFn deleteRoleByIdFn
  return useQuery({
    queryKey: [USER_ROLES],
    queryFn: getRolesFn,
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {},
  });
};

export const useAddRole = () => {
  return useMutation({
    mutationFn: (payload) => addRoleByIdFn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_ROLES] });
    },
  });
};

export const useUpdateRole = () => {
  return useMutation({
    mutationFn: (payload) => updateRoleByIdFn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_ROLES] });
    },
  });
};

export const useDeleteRole = () => {
  return useMutation({
    mutationFn: (payload) => deleteRoleByIdFn(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USER_ROLES] });
    },
  });
};
